import { render, staticRenderFns } from "./WalletOrder.html?vue&type=template&id=7068c740&external"
import script from "./WalletOrder.js?vue&type=script&lang=js&external"
export * from "./WalletOrder.js?vue&type=script&lang=js&external"
import style0 from "./WalletOrder.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports